import OptimizedLink from "../../Atoms/OptimizedLink";
import { locationIds } from "../../../core/enums";
import { NearViewportCloudinaryImage } from "../../Atoms/Cloudinary";
import styles from "./styles.module.scss";

// How far outside the viewport the banner starts loading.
const BANNER_LOAD_MARGIN = "300px";

type CustomBannerProps = {
  from: string;
};

export default function CustomTourBanner({ from }: CustomBannerProps) {
  const isThailand = from === locationIds.BANGKOK;

  const desktopSrc = isThailand
    ? "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,w_1126,h_201/v1765336505/custom-tours/thailand/banners/banner_custom_thai.png"
    : "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,w_1126,h_201/v1759215194/custom-tours/banner_custom_large.jpg";
  const mobileSrc = isThailand
    ? "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,w_243,h_375/v1767664222/custom-tours/thailand/banners/thai_custom_port.png"
    : "https://res.cloudinary.com/dbm1qiew0/image/upload/f_auto,q_auto,w_243,h_375/v1760583984/custom-tours/banner_custom_largell.png";

  return (
    <div className={styles.CustomTourBannerImage}>
      <OptimizedLink
        href={`/custom-tour/${isThailand ? "thailand/" : "japan/"}?ref=${from}`}
        target="_blank"
      >
        <NearViewportCloudinaryImage
          loadMargin={BANNER_LOAD_MARGIN}
          src={{ mobile: mobileSrc, tablet: desktopSrc, web: desktopSrc }}
          alt={
            isThailand
              ? "Thailand Travel Custom Tour"
              : "Japan Travel Custom Tour"
          }
          objFit={"inherit"}
        />
      </OptimizedLink>
    </div>
  );
}
